import { useTranslation } from 'react-i18next';
import { affiliationTypesOptions } from '../../../utils/actors';

import './Filter.scss';


export const AffiliationTypesChooser = ({ onChange, selected = [] }) => {
  const { t } = useTranslation();

  const options = affiliationTypesOptions(t);

  const handleSelect = () => {
    if (options.length !== selected.length) {
      onChange(options.map(opt => opt.value));
    } else {
      onChange([]);
    }
  };

  return (
    <div className='chooser'>
      <div className='control' onClick={() => handleSelect()}>
        {options.length === selected.length ? t('Deselect all') : t('Select all')}
      </div>
      <ul>
        {options.map(opt => (
          <li key={opt.value}>
            <input
              id={`affiliation_type_${opt.value}`}
              type='checkbox'
              checked={selected.includes(opt.value)}
              onChange={() => {
                if (selected.includes(opt.value)) {
                  onChange(selected.filter(v => v !== opt.value));
                } else {
                  onChange([...selected, opt.value]);
                }
              }}
            />
            <label htmlFor={`affiliation_type_${opt.value}`}>{opt.label}</label>
          </li>
        ))}
      </ul>
    </div>
  );
};
